import { apiRequest } from './apiClient';

export const HAKEDIS_FATURA_BEKLEYEN_SAYAC_YENILE_EVENT = 'hakedis-fatura-bekleyen-refresh';

/**
 * Hakedişleri listele
 * @param {Object} params - sayfa, limit, teknikServisId, durum, tab (fatura-bekleyen | odeme-bekleyen | tamamlanan)
 */
export const fetchHakedisler = async ({ sayfa = 1, limit = 10, teknikServisId, durum, tab, arama } = {}) => {
  const queryParams = {};
  if (sayfa) queryParams.sayfa = sayfa;
  if (limit) queryParams.limit = limit;
  if (teknikServisId) queryParams.teknikServisId = teknikServisId;
  if (durum) queryParams.durum = durum;
  if (tab) queryParams.tab = tab;
  if (arama != null && String(arama).trim() !== '') queryParams.arama = String(arama).trim();

  const response = await apiRequest('/api/hakedisler', {
    method: 'GET',
    query: queryParams,
  });

  return response;
};

/** TP sidebar: oturum açan teknik servise ait fatura bekleyen hakediş sayısı */
export const fetchHakedisFaturaBekleyenSayisi = async () => {
  const response = await fetchHakedisler({ tab: 'fatura-bekleyen', sayfa: 1, limit: 1 });
  return response?.veri?.sayfalama?.toplam ?? 0;
};

/**
 * Hakediş detayını getir
 */
export const fetchHakedisDetay = async (hakedisId) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}`, {
    method: 'GET',
  });

  return response;
};

/**
 * Randevu ID'ye göre hakediş getir
 */
export const fetchHakedisByRandevuId = async (randevuId) => {
  try {
    // Backend'den randevuId parametresi ile doğrudan filtrele (optimize edildi)
    const response = await apiRequest('/api/hakedisler', {
      method: 'GET',
      query: { randevuId },
    });

    if (response?.basarili && response?.veri?.hakedisler) {
      // Backend randevuId ile filtrelediği için sonuç tek bir hakediş veya boş array olacak
      const hakedis = response.veri.hakedisler.length > 0 ? response.veri.hakedisler[0] : null;
      return hakedis ? { basarili: true, veri: { hakedis } } : { basarili: false, veri: { hakedis: null } };
    }

    return { basarili: false, veri: { hakedis: null } };
  } catch (error) {
    console.error('Hakediş getirme hatası:', error);
    return { basarili: false, veri: { hakedis: null } };
  }
};

/**
 * Hakedişe fatura bilgisi ekle (Teknik Servis)
 */
export const hakedisFaturaGir = async (hakedisId, faturaNumarasi) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}/fatura`, {
    method: 'PATCH',
    body: { faturaNumarasi: String(faturaNumarasi || '').trim() },
  });

  return response;
};

/**
 * Hakediş güncelle (Admin - OnayBekliyor iken)
 */
export const hakedisGuncelle = async (hakedisId, { yapilanIslemler, ilaveIslemler, degistirilenParcalar, yolBedeli }) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}`, {
    method: 'PATCH',
    body: { yapilanIslemler, ilaveIslemler, degistirilenParcalar, yolBedeli },
  });
  return response;
};

/**
 * Hakediş onayla (Admin)
 */
export const hakedisOnayla = async (hakedisId) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}/onayla`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};

/**
 * Hakediş ödemesini kaydet (Admin)
 * @param {string} hakedisId
 * @param {Object} params - odemeYontemi (Nakit|HavaleEFT|KrediKarti|CekSenet), odemeNotu (opsiyonel)
 */
export const odemeYapHakedis = async (hakedisId, { odemeYontemi, odemeNotu } = {}) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}/odeme`, {
    method: 'PATCH',
    body: { odemeYontemi, odemeNotu: odemeNotu || '' },
  });

  return response;
};

/**
 * Hakediş iptal et (Admin)
 * Hakediş tamamen iptal edilir; cari hareketler varsa ters kayıt oluşturulur.
 */
export const hakedisIptal = async (hakedisId) => {
  const response = await apiRequest(`/api/hakedisler/${hakedisId}/iptal`, {
    method: 'PATCH',
    body: {},
  });
  return response;
};
